<script>
  export let log;
</script>

<style>
  td.fecha {
    width: 20%;
    font-size: 13px;
  }

  td.descripcion {
    width: 80%;
  }
</style>

<tr>
  <td class="fecha">{log.fecha}</td>
  <td class="descripcion">{log.descripcion}</td>
</tr>
